import React, { useState } from "react";
import { ArrowUpRight, Zap } from "lucide-react";

export const CoreServiceCard = ({ service }) => {
  const [selected, setSelected] = useState(false);
  return (
    <button type="button" className={`core-service-card ${selected ? "is-selected" : ""}`} onClick={() => setSelected(!selected)} aria-pressed={selected} data-testid={`service-card-${service.id}`}>
      <span className="core-service-top">
        <span className="core-service-number font-heading">{service.no}</span>
        <span className="core-service-badge">{service.badge}</span>
      </span>
      <span className="core-service-title font-heading" data-testid={`core-title-${service.id}`}>{service.title}</span>
      <span className="core-service-desc" data-testid={`core-description-${service.id}`}>{service.desc}</span>
      <span className="core-service-highlights" data-testid={`core-highlights-${service.id}`}>
        {service.highlights.slice(0, 3).map((highlight) => (
          <span key={highlight}><Zap size={15} aria-hidden="true" />{highlight}</span>
        ))}
      </span>
      <ArrowUpRight className="core-service-arrow" size={22} aria-hidden="true" />
    </button>
  );
};